import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import image from "../../assets/switching/professional/pro-max-48-poe.png";
import type { Product } from "../../types";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const professionalMax48PoE: Product = {
  id: "professionalMax48PoE",
  productTitle: "Pro Max 48 PoE",
  description: "professionalMax48PoE.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-max-48-poe"],
  storePathParts: {
    productSlug: "usw-pro-max-48-poe",
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
  },
  sku: "USW-Pro-Max-48-PoE",
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingProfessional,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442.4 x 400 x 44 mm\n(17.4 x 15.7 x 1.7")',
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "48 + 4 SFP+" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo2_5Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "720 W" },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.unifiPowerBackupReady",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: true },
    },

    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
  ],
};
